import type { FaireProductEntity } from "../../entity_types/product";

export const p_mrjufdgkaj: FaireProductEntity = {
  token: "p_mrjufdgkaj",
  type: "product",
  name: "Recycled Acrylic Hoops",
  brandToken: "b_9i4twtz8",
  brandName: "WOLL",
  imageUrl:
    "https://cdn.faire.com/fastly/0a8184cae95ada77024b4f10913089a797a9e19dc2cb8436818b736bfc6c0df7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d3cbeebe139e0130c191e99e111bba2a0d8c8e870b919e99caf4a1fbb505b67b.jpeg",
  ],
  priceDollars: 22.5,
  description:
    "These simple hoops are made from recycled acrylic and sterling silver findings.\n\nThese recycled earrings are all unique but the colors used will be the ones pictured:\nClear/Pink/NeonGreen/Melon\n\n1”",
  tags: [],
  msrpDollars: 45,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:37:46.216Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
